import React from 'react';

/**
 * ChangeSummarySection - Visar ändringssammanfattning för kund vid v1.1+
 *
 * Renderas bara om changeSummary finns och inte är tom.
 */
const ChangeSummarySection = ({ changeSummary, version }) => {
  if (!changeSummary) return null;

  return (
    <div className="bg-yellow-50 rounded-lg shadow-sm border border-yellow-300 mb-6">
      <div className="p-6">
        <div className="flex items-start space-x-3">
          <div className="flex-shrink-0">
            <svg className="w-5 h-5 text-yellow-600 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-yellow-800">
              Ändringar i version {version}
            </h3>
            <p className="mt-1 text-sm text-yellow-700 whitespace-pre-line">
              {changeSummary}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeSummarySection;
